import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FavoriteSupplierCard = ({ supplier, onViewProfile, onRemoveFavorite }) => {
  const renderRatingStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name={index < Math.floor(rating) ? 'Star' : 'StarHalf'}
        size={12}
        color={index < rating ? '#F59E0B' : '#D1D5DB'}
        className="fill-current"
      />
    ));
  };

  return (
    <div className="bg-card rounded-xl shadow-warm p-4 hover:shadow-warm-md transition-smooth">
      <div className="flex items-start gap-3 mb-3">
        <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
          <Image
            src={supplier?.avatar}
            alt={supplier?.avatarAlt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <h4 className="font-heading font-semibold text-base line-clamp-1">
              {supplier?.name}
            </h4>
            <button
              onClick={() => onRemoveFavorite(supplier?.id)}
              className="flex-shrink-0 p-1 hover:bg-muted rounded-md transition-smooth"
            >
              <Icon name="Heart" size={16} color="var(--color-accent)" className="fill-current" />
            </button>
          </div>
          <div className="flex items-center gap-1 mb-1">
            {renderRatingStars(supplier?.rating)}
            <span className="text-xs text-muted-foreground ml-1">
              ({supplier?.reviewCount})
            </span>
          </div>
          <p className="text-xs text-muted-foreground line-clamp-1">
            {supplier?.specialties?.join(', ')}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 mb-3 text-xs text-muted-foreground">
        <span className="flex items-center gap-1">
          <Icon name="MapPin" size={12} />
          {supplier?.distance}
        </span>
        <span className="flex items-center gap-1">
          <Icon name="Clock" size={12} />
          {supplier?.deliveryTime}
        </span>
      </div>
      <Button
        variant="outline"
        size="sm"
        fullWidth
        iconName="Store"
        onClick={() => onViewProfile(supplier)}
      >
        View Kitchen
      </Button>
    </div>
  );
};

export default FavoriteSupplierCard;